// Shared helpers for "header" analysis (heading the ball in soccer / Gaelic
// football). A header is any impact at or above DEFAULT_HEADER_THRESHOLD_G.

export const DEFAULT_HEADER_THRESHOLD_G = 10;

// Teams that always show header analysis, regardless of their sport field.
// Use for demos or teams whose sport isn't classified as a heading sport.
const HEADER_TRACKING_TEAM_IDS = new Set(["sit-team-a4e85ab7e05248"]);

// Whether a team should surface header analysis. Matches heading sports by name
// ("Soccer", "Football", "Gaelic Football") or an explicit team allow-list.
export const teamTracksHeaders = ({ sport, teamId } = {}) =>
  /soccer|football|gaelic/i.test(sport || "") ||
  HEADER_TRACKING_TEAM_IDS.has(teamId);
